import { Extension, Person, Policy } from "@mui/icons-material";
import HomeIcon from "@mui/icons-material/Home";
import WorkIcon from "@mui/icons-material/Work";
import {
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { appRoutes } from "../../../constant/constant";
const AgentMenu = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <Divider />
      <List sx={{ py: 1 }}>
        <ListItem
          disablePadding
          sx={{ borderRadius: 2, overflow: "hidden", my: 0.5 }}
        >
          <ListItemButton
            onClick={() => navigate("")}
            selected={isActive("")}
            sx={{
              borderRadius: 2,
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "success.light",
                "& .MuiListItemIcon-root": {
                  color: "warning.main",
                },
              },
              "&.Mui-selected": {
                backgroundColor: "success.main",
                color: "common.white",
                "& .MuiListItemIcon-root": {
                  color: "warning.main",
                },
                "&:hover": {
                  backgroundColor: "success.dark",
                },
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: 40 }}>
              <HomeIcon
                sx={{
                  color: isActive(appRoutes.home)
                    ? "warning.main"
                    : "text.secondary",
                  transition: "color 0.3s ease",
                }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Home"
              primaryTypographyProps={{
                fontWeight: isActive(appRoutes.home) ? "bold" : "normal",
              }}
            />
          </ListItemButton>
        </ListItem>
        <ListItem
          disablePadding
          sx={{ borderRadius: 2, overflow: "hidden", my: 0.5 }}
        >
          <ListItemButton
            onClick={() => navigate(appRoutes.adminAssure)}
            selected={isActive(appRoutes.adminAssure)}
            sx={{
              borderRadius: 2,
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "success.light",
                "& .MuiListItemIcon-root": {
                  color: "warning.main",
                },
              },
              "&.Mui-selected": {
                backgroundColor: "success.main",
                color: "common.white",
                "& .MuiListItemIcon-root": {
                  color: "warning.main",
                },
                "&:hover": {
                  backgroundColor: "success.dark",
                },
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: 40 }}>
              <Person
                sx={{
                  color: isActive(appRoutes.adminAssure)
                    ? "warning.main"
                    : "text.secondary",
                  transition: "color 0.3s ease",
                }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Assurés"
              primaryTypographyProps={{
                fontWeight: isActive(appRoutes.adminAssure) ? "bold" : "normal",
              }}
            />
          </ListItemButton>
        </ListItem>
      </List>
      <ListItem
        disablePadding
        sx={{ borderRadius: 2, overflow: "hidden", my: 0.5 }}
      >
        <ListItemButton
          onClick={() => navigate(appRoutes.adminContrats)}
          selected={isActive(appRoutes.adminContrats)}
          sx={{
            borderRadius: 2,
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "success.light",
              "& .MuiListItemIcon-root": {
                color: "warning.main",
              },
            },
            "&.Mui-selected": {
              backgroundColor: "success.main",
              color: "common.white",
              "& .MuiListItemIcon-root": {
                color: "warning.main",
              },
              "&:hover": {
                backgroundColor: "success.dark",
              },
            },
          }}
        >
          <ListItemIcon sx={{ minWidth: 40 }}>
            <WorkIcon
              sx={{
                color: isActive(appRoutes.adminContrats)
                  ? "warning.main"
                  : "text.secondary",
                transition: "color 0.3s ease",
              }}
            />
          </ListItemIcon>
          <ListItemText
            primary="Contrats ass.."
            primaryTypographyProps={{
              fontWeight: isActive(appRoutes.adminContrats) ? "bold" : "normal",
            }}
          />
        </ListItemButton>
      </ListItem>
      <Divider color="success" />
      <List sx={{ py: 1 }}>
        <ListItem
          disablePadding
          sx={{ borderRadius: 2, overflow: "hidden", my: 0.5 }}
        >
          <ListItemButton
            onClick={() => navigate(appRoutes.adminPolice)}
            selected={isActive(appRoutes.adminPolice)}
            sx={{
              borderRadius: 2,
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "success.light",
                "& .MuiListItemIcon-root": {
                  color: "warning.main",
                },
              },
              "&.Mui-selected": {
                backgroundColor: "success.main",
                color: "common.white",
                "& .MuiListItemIcon-root": {
                  color: "warning.main",
                },
                "&:hover": {
                  backgroundColor: "success.dark",
                },
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: 40 }}>
              <Policy
                sx={{
                  color: isActive(appRoutes.adminPolice)
                    ? "warning.main"
                    : "text.secondary",
                  transition: "color 0.3s ease",
                }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Polices"
              primaryTypographyProps={{
                fontWeight: isActive(appRoutes.adminPolice) ? "bold" : "normal",
              }}
            />
          </ListItemButton>
        </ListItem>

        <ListItem
          disablePadding
          sx={{ borderRadius: 2, overflow: "hidden", my: 0.5 }}
        >
          <ListItemButton
            onClick={() => navigate(appRoutes.module)}
            selected={isActive(appRoutes.module)}
            sx={{
              borderRadius: 2,
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "success.light",
                "& .MuiListItemIcon-root": {
                  color: "warning.main",
                },
              },
              "&.Mui-selected": {
                backgroundColor: "success.main",
                color: "common.white",
                "& .MuiListItemIcon-root": {
                  color: "warning.main",
                },
                "&:hover": {
                  backgroundColor: "success.dark",
                },
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: 40 }}>
              <Extension
                sx={{
                  color: isActive(appRoutes.module)
                    ? "warning.main"
                    : "text.secondary",
                  transition: "color 0.3s ease",
                }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Modules"
              primaryTypographyProps={{
                fontWeight: isActive(appRoutes.module) ? "bold" : "normal",
              }}
            />
          </ListItemButton>
        </ListItem>
      </List>
    </>
  );
};

export default AgentMenu;
